import { AutocompleteRenderGroupParams, Stack, Typography } from '@mui/material'

export const AssigneeAutocompleteGroup = ({ children, group }: AutocompleteRenderGroupParams) => {
  const groupLength = children && Array.isArray(children) ? children.length : 0
  return (
    <Stack>
      <Typography variant="small-regular" color="neutral.main" sx={{ padding: '12px 16px' }}>
        {group} {groupLength > 0 && `(${groupLength})`}
      </Typography>
      {children}
    </Stack>
  )
}
